<nav [class]="styleClass()">
  @for (item of items(); track item.id || item.label) {
    @if (item.dropdownItems?.length) {
      <div
        class="nav-item-dropdown"
        (mouseenter)="onDropdownMouseEnter(item)"
        (mouseleave)="onDropdownMouseLeave()">
        <button type="button" class="nav-item">
          <span>{{ item.label }}</span>
          <htx-icon class="nav-item-arrow" [class.open]="isDropdownOpen(item)" icon="arrow_drop_down"></htx-icon>
        </button>
        @if (isDropdownOpen(item)) {
          <div class="dropdown-menu">
            @for (dropdownItem of item.dropdownItems; track dropdownItem.value) {
              <button
                class="dropdown-item"
                [class.disabled]="dropdownItem.disabled"
                [disabled]="dropdownItem.disabled"
                (click)="selectDropdownItem(dropdownItem)">
                @if (dropdownItem.icon) {
                  <htx-icon [icon]="dropdownItem.icon"></htx-icon>
                }
                <span>{{ dropdownItem.label }}</span>
              </button>
            }
          </div>
        }
      </div>
    } @else {
      <button
        type="button"
        (click)="onItemClick(item)"
        class="nav-item">
        <ng-container *ngIf="itemTemplate(); else defaultTemplate">
          <ng-container *ngTemplateOutlet="itemTemplate()!; context: { $implicit: item }"></ng-container>
        </ng-container>
        <ng-template #defaultTemplate>
          <span>{{ item.label }}</span>
        </ng-template>
      </button>
    }
  }
</nav>
